import React, { useContext, useEffect, useState } from "react";
import { authenticatedContext, userDataContext } from "../App";
import {ButtonWIcon} from './Inputs'
import '../css/project_admin.css'; 
import Table from "./Table";
import { useNavigate } from "react-router-dom";


const ProjectAdmin = () => {
  const {authenticated, setAuthenticated} = useContext(authenticatedContext);
  const {userData, setUserData} = useContext(userDataContext);

  const [inNameFull, setInNameFull] = useState("");
  const [inNameFullSort, setInNameFullSort] = useState(0); // -1 desc, 0 none, 1 asc
  const [inNameShort, setInNameShort] = useState("");
  const [inNameShortSort, setInNameShortSort] = useState(0); // -1 desc, 0 none, 1 asc
  
  const [reqUrl, setReqUrl] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
  
    setReqUrl(`/projects/filter/${inNameFull || "null"}/${inNameFullSort}/${inNameShort || "null"}/${inNameShortSort}`);
  },[inNameFull, inNameShort, inNameFullSort, inNameShortSort])

  return (
    <div className="project-admin">      
      <div className="heading-controls">
        <h3>Správa projektů</h3>
        <ButtonWIcon text={"Přidat projekt"} iconSrc={"/img/svg/add.svg"} onClick={()=>{navigate('/project/create')}}/>
      </div>
      <Table 
        reqUrl={reqUrl}
        redirectOnRecordClick={true}
        headers={[
         {
          name:"Celý název",
          dataKey: "name",
          search: {
            value: inNameFull,
            setValue: setInNameFull
          },
          sort:{
            value: inNameFullSort,
            setValue: setInNameFullSort
          },
          type: "text",
        },
         {
          name:"Zkrácený název",
          dataKey: "short_name",
          search: {
            value: inNameShort,
            setValue: setInNameShort
          },
          sort:{
            value: inNameShortSort,
            setValue: setInNameShortSort
          },
          type: "text",
        },
         {
          name:"Počet klientů",
          dataKey: "client_count",
          search: false,
          sort:false,
          type: "text",
        } 
        ]}
        actions={{
          requestBase: "/project/",
          recordIdKey: "project_id"
        }}
      />
    </div>
  );
};

export default ProjectAdmin;